import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const editSurveyRewardsAction = createAsyncThunk(
    'edit-rewards',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.patch(`/support-server/api/edit-survey-rewards`, {survey_id:data?.survey_id,secondaryRewards:data?.secondaryRewards,primaryRewards:data?.primaryRewards})
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const editSurveyRewardSlice = createSlice({
    name: 'delete-survey',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(editSurveyRewardsAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(editSurveyRewardsAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(editSurveyRewardsAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const editSurveyRewardReducer = editSurveyRewardSlice.reducer    